import { call, put } from "redux-saga/effects";

import { apiFoco, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";

import { requestErrorHandler } from "utils";
import { CreateOuvidoriaActions } from "store/ducks/ouvidoria";

export function* CreateOuvidoriaRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;
    const { data } = yield call(apiFoco.post, `/ouvidoria`, postData);

    yield put(CreateOuvidoriaActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateOuvidoriaActions.failure(errorMessage));
  }
}
